module.exports = __webpack_public_path__ + "img/33.041fa30a.jpg";